import { FilterOperatorEnum } from '@/types/schema';

import { FilterGroupInput } from '../types';

export const EMPTY_FILTER = {
  operator: undefined,
  property: undefined,
  value: undefined,
};

export const EMPTY_GROUP = {
  operator: FilterOperatorEnum.And,
  filters: [EMPTY_FILTER],
};

export const DEFAULT_GROUP: FilterGroupInput = {
  operator: FilterOperatorEnum.And,
  filters: [],
};

export const VALUE_DISABLED_FOR_OPERATORS = [
  FilterOperatorEnum.IsEmpty,
  FilterOperatorEnum.IsNotEmpty,
];

export const RESET_VALUE_FOR_OPERATORS = [
  ...VALUE_DISABLED_FOR_OPERATORS,
  FilterOperatorEnum.Between,
];
